module.exports = __webpack_public_path__ + "static/media/SL.f6c17dd3.png";